import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { Button } from '../../../../../components/Button/Button'
import { useNavigate } from 'react-router-dom'

export interface MeetingScorecardDisabledProps {}

export const MeetingScorecardDisabled: React.FC<MeetingScorecardDisabledProps> = () => {
  const navigate = useNavigate()
  const handleEnableSettings = () => {
    navigate('/workspace/setup/settings')
  }

  return (
    <Row className='d-flex flex-column align-items-center text-center w-100'>
      <Container className='d-flex justify-content-center align-items-center'>
        <Row className='w-50'>
          <Col className='text-center justify-content-center pt-5'>
            <div className='circle-outer'>
              <div className='circle-middle'>
                <div className='circle-inner'>
                  <h1 className='bold zocks-text-gray-500'>?</h1>
                </div>
              </div>
            </div>
            <h6 className='pt-4'>Meeting Score is currently turned off</h6>
            <ScopedBlock
              scope={{
                scope: 'account:update',
                superScope: ['account:admin'],
              }}
              missingScopeAction={MissingScopeAction.REPLACE}
              replaceElement={
                <div>Contact your account owner to enable Meeting Scoring by AI Assistant and start tracking performance insights for future meetings.</div>
              }
            >
              <div className='pb-4'>
                Enable Meeting Scoring by AI Assistant in Settings to start tracking performance insights for future meetings. Past meetings won't be analyzed
                automatically.
              </div>
              <div className='d-flex justify-content-center'>
                <Button variant='primary' onClick={handleEnableSettings}>
                  Enable in Settings
                </Button>
              </div>
            </ScopedBlock>
          </Col>
        </Row>
      </Container>
    </Row>
  )
}
